import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'college-profile.header',
    defaultMessage: 'View or Edit Your College Profile in Naviance',
  },
  getStartedButton: {
    id: 'college-profile.getStarted',
    defaultMessage: 'Get Started',
  },
  content1: {
    id: 'college-profile.content1',
    defaultMessage: 'In Intersect, higher education users can manage, and add to, the information provided on their college profile in Family Connection. ', // eslint-disable-line max-len
  },
  content2: {
    id: 'college-profile.content2',
    defaultMessage: 'Family Connection is the student and parent portal that is part of the larger Naviance system - a comprehensive K-12 college and career readiness solution that helps districts and schools align student strengths and interests to postsecondary goals.', // eslint-disable-line max-len
  },
  content3: {
    id: 'college-profile.content3',
    defaultMessage: 'College profiles can be displayed to students and parents in Family Connection as early as 6th grade, and are used through 12th grade to manage the college research and application process.', // eslint-disable-line max-len
  },
  edit: {
    id: 'college-profile.edit',
    defaultMessage: 'Edit your college profile',
  },
  editDescription: {
    id: 'college-profile.editDescription',
    defaultMessage: 'To get started – choose a category.',
  },
  profileMenuItem: {
    id: 'college-profile.links-and-profiles.profile-menu-item',
    defaultMessage: 'Spotlights',
  },
  premiumFeatureLink: {
    id: 'college-profile.links-and-profiles.premium-feature-link',
    defaultMessage: 'Premium Features',
  },
  linksMenuItem: {
    id: 'college-profile.links-and-profiles.links-menu-item',
    defaultMessage: 'Links',
  },
  photosAndVideosMenuItem: {
    id: 'college-profile.links-and-profiles.photos-and-videos-menu-item',
    defaultMessage: 'Photos and Videos',
  },
  logo: {
    id: 'college-profile.media.logo',
    defaultMessage: 'Logo',
  },
  aboutUs: {
    id: 'college-profile.intro.aboutUs',
    defaultMessage: 'About Us',
  },
  mediaHeader: {
    id: 'college-profile-page.media-page.media-header',
    defaultMessage: 'Media',
  },
  mediaSubheader: {
    id: 'college-profile-page.media-page.media-subheader',
    defaultMessage:
      "Use the menu on the left to manage the logo, photos and videos that are displayed on your institution's Naviance college profile.",
  },
  logoHeader: {
    id: 'college-profile-page.media-page.logoheader',
    defaultMessage: 'Logo',
  },
  photosAndVideosHeader: {
    id: 'college-profile-page.media-page.photos-and-videos-header',
    defaultMessage: 'Photos and Videos',
  },
  profileDeletionConfirm: {
    id: 'college-profile-page.media-page.profile-deletion-confirm',
    defaultMessage: 'Are you sure you want to delete this spotlight?',
  },
  cancelDeletion: {
    id: 'college-profile-page.media-page.cancel',
    defaultMessage: 'CANCEL',
  },
  deleteProfile: {
    id: 'college-profile-page.media-page.delete',
    defaultMessage: 'DELETE',
  },
  photosInstructions: {
    id: 'college-profile-page.photos-and-videos-modal.photos-instructions',
    defaultMessage: 'Please choose a tile to fill with an image or video.',
  },
  photosInstructionsV2: {
    id: 'college-profile-page.photos-and-videos-modal.photos-instructions-v2',
    defaultMessage: 'Click a tile to upload an image or video. The first image in your gallery appears on your institution\'s College Match card in Naviance Student.',
  },
  photosPrompt: {
    id: 'college-profile-page.photos-and-videos-modal.photos-prompt',
    defaultMessage: 'What type of media would you like to use in this tile?',
  },
  photoButton: {
    id: 'college-profile-page.photos-and-videos-modal.photos-prompt.photo-button',
    defaultMessage: 'PHOTO',
  },
  videoButton: {
    id: 'college-profile-page.photos-and-videos-modal.photos-prompt.video-button',
    defaultMessage: 'VIDEO',
  },
  addOrEditVideo: {
    id: 'college-profile-page.photos-and-videos-modal.videos-prompt.add-or-edit-video',
    defaultMessage: 'Add or edit a video to associate with this tile.',
  },
  addOrEditVideoLabel: {
    id: 'college-profile-page.photos-and-videos-modal.videos-prompt.add-or-edit-video-label',
    defaultMessage: 'Vimeo or Youtube URL',
  },
  addOrEditVideoCaption: {
    id: 'college-profile-page.photos-and-videos-modal.videos-prompt.add-or-edit-caption',
    defaultMessage: 'Provide an optional caption to be displayed with the video.',
  },
  noLogoMessage: {
    id: 'college-profile-page.media-page.no-logo-uploaded',
    defaultMessage: 'No logo uploaded.',
  },
  noProfiles: {
    id: 'college-profile-page.media-page.no-profile-uploaded',
    defaultMessage: 'No spotlights created',
  },
  createNewProfile: {
    id: 'college-profile-page.media-page.create-new-profile',
    defaultMessage: 'CREATE A NEW SPOTLIGHT',
  },
  createNewLink: {
    id: 'college-profile-page.media-page.create-new-link',
    defaultMessage: 'CREATE A NEW LINK',
  },
  addUpToPhotosAndVideos: {
    id: 'college-profile-page.media-page.add-up-to-media',
    defaultMessage: 'Add up to 31 photos and videos.',
  },
  linksAndProfilesHeader: {
    id: 'college-profile-page.links-and-profiles-page.links-and-profiles-header',
    defaultMessage: 'Links & Spotlights',
  },
  linksAndProfilesSubheader: {
    id: 'college-profile-page.links-and-profiles-page.links-and-profiles-subheader',
    defaultMessage: 'Use the menu on the left to manage links and spotlights for your institution.',
  },
  linksHeader: {
    id: 'college-profile-page.links-and-profiles-page.links-header',
    defaultMessage: 'Links',
  },
  linksSubheader: {
    id: 'college-profile-page.links-and-profiles-page.links-subheader',
    defaultMessage: 'Below is a preview of how a student can interact with the links on your Naviance college profile.',
  },
  profilesHeader: {
    id: 'college-profile-page.links-and-profiles-page.profiles-header',
    defaultMessage: 'Spotlights',
  },
  profilesEmptySubheader: {
    id: 'college-profile-page.links-and-profiles-page.profiles-subheader',
    defaultMessage: 'No spotlights created. Click <i>Spotlights</i> to get started',
  },
  profilesReadMoreButton: {
    id: 'college-profile-page.links-and-profiles-page.profiles.read-more-button',
    defaultMessage: 'READ MORE',
  },
  profilesShowLessButton: {
    id: 'college-profile-page.links-and-profiles-page.profiles.show-less-button',
    defaultMessage: 'SHOW LESS',
  },
  profilesFavActivitiesTitle: {
    id: 'college-profile-page.links-and-profiles-page.profiles.fav-activities-title',
    defaultMessage: 'Favorite campus activities:',
  },
  profilesFavHangoutTitle: {
    id: 'college-profile-page.links-and-profiles-page.profiles.fav-hangouts-title',
    defaultMessage: 'Favorite campus hangout:',
  },
  profilesBestPlaceToEatTitle: {
    id: 'college-profile-page.links-and-profiles-page.profiles.best-place-to-eat-title',
    defaultMessage: 'Where is the best place to eat on campus?',
  },
  profilesFavEventTitle: {
    id: 'college-profile-page.links-and-profiles-page.profiles.fav-event-title',
    defaultMessage: 'Favorite campus-wide event:',
  },
  profilesFavTraditionsTitle: {
    id: 'college-profile-page.links-and-profiles-page.profiles.fav-tradition-title',
    defaultMessage: 'Favorite school tradition:',
  },
  profilesTravelTitle: {
    id: 'college-profile-page.links-and-profiles-page.profiles.travel-title',
    defaultMessage: 'Car, bus, or bike – how do most students travel:',
  },
  frameEditTitle: {
    id: 'college-profile.frame.title',
    defaultMessage: 'Hubs Edit',
  },
  back: {
    id: 'drop-zone.back',
    defaultMessage: 'Back',
  },
  next: {
    id: 'edit-photo-or-video-modal.next',
    defaultMessage: 'Next',
  },
  save: {
    id: 'edit-photo-or-video-modal.save',
    defaultMessage: 'Save',
  },
  previewAndContinue: {
    id: 'drop-zone.previewAndContinue',
    defaultMessage: 'PREVIEW AND CONTINUE EDITING',
  },
  titleCropping: {
    id: 'drop-zone.titleCropping',
    defaultMessage: 'Crop and move the logo to the position in the tile that fits best.',
  },
  nevermindBack: {
    id: 'drop-zone.nevermindBack',
    defaultMessage: 'Never mind, take me back.',
  },
  imageUploading: {
    id: 'drop-zone.imageUploading',
    defaultMessage: 'Uploading image...',
  },
  publishMediaModalTitle: {
    id: 'premium-hem.publish-media-modal.title',
    defaultMessage: 'Publish your media changes?',
  },
  publishIntroModalTitle: {
    id: 'premium-hem.publish-intro-modal.title',
    defaultMessage: 'Publish your intro changes?',
  },
  publishBasicInfoModalTitle: {
    id: 'premium-hem.publish-basic-info-modal.title',
    defaultMessage: 'Publish your basic info changes?',
  },
  publishLinksAndProfilesModalTitle: {
    id: 'premium-hem.publish-links-and-profiles-modal.title',
    defaultMessage: 'Publish your links & spotlights changes?',
  },
  publishModalContent: {
    id: 'premium-hem.publish-modal.content',
    defaultMessage: 'Unpublished changes will not be accessible after you leave the Naviance College Profile Editor.',
  },
  publishModalCloseButton: {
    id: 'premium-hem.publish-modal.close-button',
    defaultMessage: 'Continue editing',
  },
  publishModalContinueButton: {
    id: 'premium-hem.publish-modal.continue-button',
    defaultMessage: 'Disregard my changes',
  },
  publishModalPublishButton: {
    id: 'premium-hem.publish-modal.publish-button',
    defaultMessage: 'Publish',
  },
  confirmationModalTitle: {
    id: 'premium-hem.confirmation-modal.title',
    defaultMessage: "You're almost done!",
  },
  confirmationModalApprovalDisclaimer: {
    id: 'premium-hem.confirmation-modal.approval-disclaimer',
    defaultMessage: 'The following items you\'ve updated need approval by Intersect.',
  },
  confirmationModalApprovalDisclaimerTime: {
    id: 'premium-hem.confirmation-modal.approval-disclaimer-time',
    defaultMessage: 'The approval process can take up to 24-48 hours.',
  },
  confirmationModalJustifyChanges: {
    id: 'premium-hem.confirmation-modal.justify-changes',
    defaultMessage: 'Please provide a brief explanation for the changes:',
  },
  confirmationModalTextboxPlaceholder: {
    id: 'premium-hem.confirmation-modal.textbox-placeholder',
    defaultMessage: "IE: We've moved the admissions office!",
  },
  confirmationModalCloseButton: {
    id: 'premium-hem.confirmation-modal.close-button',
    defaultMessage: 'Cancel and continue editing',
  },
  confirmationModalSubmitButton: {
    id: 'premium-hem.confirmation-modal.submit-button',
    defaultMessage: 'Submit changes',
  },
  successModalTitle: {
    id: 'premium-hem.success-modal.title',
    defaultMessage: 'Great! You\'ve updated your college profile.',
  },
  successModalText: {
    id: 'premium-hem.success-modal.text',
    defaultMessage: 'Your updates have been received! Any changes you made that do not require ' +
                    'approval will be visible immediately on your college profile.',
  },
  successModalButton: {
    id: 'premium-hem.success-modal.button',
    defaultMessage: 'Continue editing',
  },
  frameViewTitle: {
    id: 'college-profile.view.frame.title',
    defaultMessage: 'Hubs View',
  },
  confirmModalListIntro: {
    id: 'premium-hem.confirmation-modal.list.intro',
    defaultMessage: 'Intro - About Us',
  },
  confirmModalListMedia: {
    id: 'premium-hem.confirmation-modal.list.media',
    defaultMessage: 'Media - Photos & Videos, Logo',
  },
  confirmModalListLinksAndProfiles: {
    id: 'premium-hem.confirmation-modal.list.links-and-profiles',
    defaultMessage: 'Links & Spotlights - Links, Spotlights',
  },
  editLogoModalInstructions2: {
    id: 'drop-zone.instructions2',
    defaultMessage: 'A square logo will fit best in the available space.',
  },
  editAboutUsPhotoModalInstructions2: {
    id: 'college-profile-page.about-us.upload-photo-instructions2',
    defaultMessage: 'A square photo will fit best in the available space.',
  },
  editAboutUsModalHeader: {
    id: 'college-profile-page.about-us-modal.header',
    defaultMessage: 'Edit About Us',
  },
  editAboutUsQuoteInputPlaceholder: {
    id: 'college-profile-page.about-us-modal.quote-input-placeholder',
    defaultMessage: 'A moving quote about your college.',
  },
  editAboutUsModalUploadPhoto: {
    id: 'college-profile-page.about-us-modal.upload-photo',
    defaultMessage: 'Upload Photo',
  },
  editAboutUsModalEditPhoto: {
    id: 'college-profile-page.about-us-modal.edit-photo',
    defaultMessage: 'Edit Photo',
  },
  continueEditingProfile: {
    id: 'college-profile-page.about-us-modal.continue-editing',
    defaultMessage: 'Continue Editing Profile',
  },
  editAboutUsConfirmDelete: {
    id: 'college-profile-page.about-us-modal.delete-confirm',
    defaultMessage: 'Are you sure you want to delete about us content?',
  },
  editAboutUsDelete: {
    id: 'college-profile-page.about-us-modal.delete',
    defaultMessage: 'DELETE',
  },
  editAboutUsDeleteCamel: {
    id: 'college-profile-page.about-us-modal.delete-camel',
    defaultMessage: 'Delete',
  },
  editAboutUsCancel: {
    id: 'college-profile-page.about-us-modal.cancel',
    defaultMessage: 'CANCEL',
  },
  editLogoModalInstructions1: {
    id: 'drop-zone.instructions1',
    defaultMessage: 'Images must be GIF, SVG, JPG or PNG format with a file size less than 20MB.',
  },
  editPhotosAndVideosModalInstructions1: {
    id: 'college-profile-page.photos-and-videos-modal.instructions1',
    defaultMessage: 'Images must be JPG or PNG format with a file size less than 20MB.',
  },
  continueEditingPhotos: {
    id: 'college-profile-page.photos-and-videos-modal.continue-editing-photos',
    defaultMessage: 'Choose a tile to continue editing your photos or videos or..',
  },
  optionalCaption: {
    id: 'college-profile-page.photos-and-videos-modal.optional-caption',
    defaultMessage: 'Provide an optional caption to be displayed with the image.',
  },
  cropPhotoInstructions1: {
    id: 'college-profile-page.photos-and-videos-modal.crop-photo-instructions1',
    defaultMessage: 'Crop and move the photo to the position that fits best.',
  },
  cropPhotoInstructions2: {
    id: 'college-profile-page.photos-and-videos-modal.crop-photo-instructions2',
    defaultMessage: 'Students can click this thumbnail to view a full size image within your institution’s Naviance college profile.',
  },
  cropPhotoInstructionsCircle: {
    id: 'college-profile-page.photos-and-videos-modal.crop-photo-instructions-circle',
    defaultMessage: 'Crop and move the photo to the position in the circle that fits best.',
  },
  editVideoHeader: {
    id: 'college-profile-page.photos-and-videos-modal.edit-video-header',
    defaultMessage: 'What would you like to do with this video?',
  },
  editPhotoHeader: {
    id: 'college-profile-page.photos-and-videos-modal.edit-photo-header',
    defaultMessage: 'What would you like to do with this image?',
  },
  editButton: {
    id: 'college-profile-page.photos-and-videos-modal.edit-button',
    defaultMessage: 'EDIT',
  },
  editCaptionButton: {
    id: 'college-profile-page.photos-and-videos-modal.edit-caption-button',
    defaultMessage: 'EDIT CAPTION',
  },
  replace: {
    id: 'college-profile-page.photos-and-videos-modal.replace',
    defaultMessage: 'Replace',
  },
  replaceWithPhoto: {
    id: 'college-profile-page.photos-and-videos-modal.replace-with-photo',
    defaultMessage: 'Replace with Photo',
  },
  removeTile: {
    id: 'college-profile-page.photos-and-videos-modal.replace-tile',
    defaultMessage: 'Want to remove this tile and use the next one in its place?',
  },
  cancel: {
    id: 'college-profile-page.photos-and-videos-modal.cancel',
    defaultMessage: 'CANCEL',
  },
  delete: {
    id: 'college-profile-page.photos-and-videos-modal.delete',
    defaultMessage: 'DELETE',
  },
  tileDeletionConfirm: {
    id: 'college-profile-page.photos-and-videos-modal.tile-deletion-confirm',
    defaultMessage: 'Are you sure you want to delete this tile?',
  },
  continueAddingInstructions: {
    id: 'college-profile-page.photos-and-videos-modal.continue-adding',
    defaultMessage: 'Choose a tile to continue editing your photos or videos',
  },
  continueAddingOr: {
    id: 'college-profile-page.photos-and-videos-modal.or',
    defaultMessage: 'or...',
  },
  previewAndContinueEditingButton: {
    id: 'college-profile-page.photos-and-videos-modal.preview-and-continue-editing',
    defaultMessage: 'Preview and continue editing your profile',
  },
});

export default messages;
